import { createSlice } from "@reduxjs/toolkit";
import { setMessage } from "features/message/messageSlice";
import { MessageType } from "features/message/types";
import { Product } from "features/ProductReel/types";
import { isMobile, isTablet } from "react-device-detect";
import { RootState } from "store/rootReducer";
import userStorage from "store/UserStorage";
import { CompareInitialState } from "./types";

const initialState: CompareInitialState = {
  update: false,
};

const allowedCompareCount = isMobile ? 2 : isTablet ? 3 : 4;

const compare = createSlice({
  name: "compare",
  initialState,
  reducers: {
    update(state, action) {
      state.update = action.payload;
    },
  },
});
export const { update } = compare.actions;
export const selectProductsToCompareUpdate = (state: RootState) =>
  state.compare.update;

export const addProductToCompare = (item: Product) => (
  dispatch: any,
  getState: () => RootState
) => {
  const storedItems = userStorage.getStoredForCompare();
  const productExists = storedItems.find((pr: any) => pr._id === item._id);

  if (productExists) {
    dispatch(
      setMessage({
        text: `Този продукт вече е добавен за сравняване`,
        type: MessageType.info,
      })
    );

    return;
  }

  if (storedItems.length === allowedCompareCount) {
    dispatch(
      setMessage({
        text: `Можете да сравнявате до ${allowedCompareCount} продукта`,
        type: MessageType.danger,
      })
    );
    return;
  }
  userStorage.addItemForCompare(item);
  const res = getState().compare.update;
  dispatch(update(!res));
  dispatch(
    setMessage({
      text: `Продуктът беше успешно добавен за сравняване`,
      type: MessageType.success,
    })
  );
};

export default compare.reducer;
